<template>
  <div class="grey4">
    <v-container style="max-width: 1200px; margin: auto" class="py-10">
      <v-row>
        <v-col cols="5">
          <img src="https://resources.eternio.com/static/blog/Blog_Autor_Philip.jpg" alt="Testimonial Image" style="border-radius: 50%;margin: auto; display: block" class="vertical-center" :style="{ width: $vuetify.breakpoint.xs ? '100%' : $vuetify.breakpoint.sm ? '70%' : '50%' }">
        </v-col>
        <v-col cols="7" :style="{ 'padding-top': $vuetify.breakpoint.mdAndUp ? '40px' : '' }">
          <div class="vertical-center">
            <h2 style="margin-bottom: 20px">So einfach waren Traueranzeigen noch nie!</h2>
            <div v-if="!$vuetify.breakpoint.xs">
              <p>
                In einem persönlichen und kostenfreien Gespräch zeige ich Ihnen gerne, wie Sie in wenigen Minuten zukünftig selbst und ohne Sorgen Traueranzeigen erstellen und veröffentlichen können.
              </p>
              <p style="font-size: 14px; margin-bottom: 40px">
                Philip Pelgen, Gründer & Geschäftsführer
              </p>

              <div>
                <v-btn
                  style="text-transform: none; width: 70%; min-width: 200px; border-radius: 10px;"
                  class="tradana-shadow white"
                  @click="openDialog"
                >
                  Kontakt aufnehmen
                </v-btn>
              </div>
            </div>
          </div>
        </v-col>
        <v-col cols="12">
          <div class="hidden-sm-and-up">
            <p>
              In einem persönlichen und kostenfreien Gespräch zeige ich Ihnen gerne, wie Sie in wenigen Minuten zukünftig selbst und ohne Sorgen Traueranzeigen erstellen und veröffentlichen können.
            </p>
            <p style="font-size: 14px; margin-bottom: 40px">
              Philip Pelgen, Gründer & Geschäftsführer
            </p>

            <div style="text-align: center">
              <v-btn
                style="text-transform: none; width: 100%; min-width: 200px; border-radius: 10px"
                class="tradana-shadow white"
                @click="openDialog"
              >
                Kontakt aufnehmen
              </v-btn>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>

    <!-- Dialogs -->
    <basic-dialog :dialog="contact" @close="contact = false">
      <p class="title mb-8">
        Wie kann ich Sie erreichen?
      </p>

      <v-alert type="error" v-model="error" style="text-align: left">
        <div class="white--text">
          Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.
        </div>
      </v-alert>

      <v-alert type="error" v-model="errorAlreadySubscribed">
        <div class="white--text">
          Wir haben bereits eine Anmeldung über die angegebene E-Mail-Adresse erhalten.
        </div>
      </v-alert>

      <v-form @submit.prevent="submit" onSubmit="return false;" ref="form" class="mb-8">
        <!-- Name -->
        <v-text-field
          label="Ihr Name"
          outlined
          :error-messages="emptyName ? 'Bitte geben sie eine valide E-Mail-Adresse ein.' : ''"
          :error="emptyName"
          v-model="name"
        >
        </v-text-field>

        <!-- Ihre Telefonnummer -->
        <v-text-field
          label="Ihre Telefonnummer"
          outlined
          :error-messages="emptyPhone ? 'Bitte geben sie eine valide E-Mail-Adresse ein.' : ''"
          :error="emptyPhone"
          v-model="phone"
        >
        </v-text-field>

        <!-- Ihre E-Mail-Adresse -->
        <v-text-field
          label="Ihre E-Mail-Adresse"
          outlined
          :error-messages="notValid ? 'Bitte geben sie eine valide E-Mail-Adresse ein.' : ''"
          :error="notValid"
          v-model="mail"
        >
        </v-text-field>

        <p style="font-size: 12px; text-align: left">
          Ihre Angaben werden ausschließlich zur Kontaktaufnahme genutzt.<br>
          Mit Klick auf senden akzeptieren Sie unsere <router-link :to="{ name: 'Privacy' }" target="_blank" class="text--text">Datenschutzerklärung</router-link>.
        </p>
      </v-form>

      <v-btn class="accept white--text" x-large width="200px" @click="send">
        Senden
      </v-btn>
    </basic-dialog>

    <!-- Success -->
    <success-dialog :dialog="success" @close="success = false">
      Vielen Dank für Ihr Interesse.<br>
      Sie werden in Kürze von uns kontaktiert.
    </success-dialog>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  data () {
    return {
      contact: false,
      name: '',
      phone: '',
      mail: '',
      emptyName: false,
      emptyPhone: false,
      notValid: false,
      success: false,
      error: false,
      errorAlreadySubscribed: false
    }
  },
  methods: {
    openDialog () {
      this.contact = true
    },
    send () {
      this.errorAlreadySubscribed = false
      this.emptyName = this.name === ''
      this.emptyPhone = this.phone === ''
      this.notValid = !(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(this.mail))

      if (this.emptyName || this.emptyPhone || this.notValid) {
        return
      }

      // ---------------- Hubspot --------------------
      var data = {
        "fields": [
          {
            "objectTypeId": "0-1",
            "name": "firstname",
            "value": this.name
          },
          {
            "objectTypeId": "0-1",
            "name": "phone",
            "value": this.phone
          },
          {
            "objectTypeId": "0-1",
            "name": "email",
            "value": this.mail
          }
        ],
        "context": {
          "pageUri": "tradana.org",
          "pageName": "TRADANA"
        },
        "legalConsentOptions": {
          "consent": { // Include this object when GDPR options are enabled
            "consentToProcess": true,
            "text": "I agree to allow eternio - Gesellschaft für Erinnerungskultur mbH to store and process my personal data.",
            "communications": [
              {
                "value": true,
                "subscriptionTypeId": 999,
                "text": "I agree to receive marketing communications from eternio - Gesellschaft für Erinnerungskultur mbH."
              }
            ]
          }
        }
      }
      axios.post('https://api.hsforms.com/submissions/v3/integration/submit/25568300/5544a9fe-1686-47dd-85f8-e96e1f553b4a', data)
      // --------------------------------------------

      axios.post('/tradana/subscribeWithName', { name: this.name, phone: this.phone, mail: this.mail })
        .then(() => {
          this.contact = false
          this.success = true
          this.errorAlreadySubscribed = false
          this.error = false
          this.$ga.event('LandingPage', 'Subscribed_with_Name', this.name + ' ' + this.phone + ' ' + this.mail, 0)
        })
        .catch(err => {
          if (err.response && err.response.status === 409) {
            this.errorAlreadySubscribed = true
          } else {
            this.error = true
          }
          this.success = false
        })
    }
  }
}
</script>
